/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { APP_INITIALIZER, CSP_NONCE, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MainModule } from './main/module';
import { UserAuthModule } from './user-auth/module';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './routing/module';

import { AppComponent } from './main/components/app/app.component';
import { SharedDataModule } from './shared-data/module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ENVIRONMENT, EnvironmentService } from '@opengamma/ui';
import { environment } from 'environments/environment';
import { AuthService } from './user-auth/services/auth.service';

@NgModule({
  bootstrap: [AppComponent],
  declarations: [],
  imports: [
    BrowserModule,
    UserAuthModule,
    SharedModule,
    MainModule,
    NgxMaterialTimepickerModule,
    SharedDataModule,
    BrowserAnimationsModule,
    MonacoEditorModule.forRoot(),
    AppRoutingModule,
    MatCardModule,
    MatDatepickerModule
  ],
  providers: [
    { provide: CSP_NONCE, useValue: 'mgmt-ui' },
    {
      provide: ENVIRONMENT,
      useValue: environment
    },
    EnvironmentService,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => () => {
        // For local-prod environment, set the access token if provided
        if (environment.accessToken) {
          authService.setAccessToken(environment.accessToken);
        }
      },
      deps: [AuthService],
      multi: true
    }
  ]
})
export class AppModule {}
